"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.TriggerText = styled_components_1.default(react_native_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    margin-right: 8px;\n    font-weight: 500;\n    text-transform: uppercase;\n"], ["\n    color: ", ";\n    margin-right: 8px;\n    font-weight: 500;\n    text-transform: uppercase;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.main.purple;
});
var templateObject_1;